var map = {
	"./de-BE.web.json": [
		"nbzM",
		156
	],
	"./en-US.web.json": [
		"yAQx",
		157
	],
	"./fr-BE.web.json": [
		"s5s1",
		158
	],
	"./nl-BE.web.json": [
		"wWmh",
		159
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "vD+5";
module.exports = webpackAsyncContext;